export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
export const PASSWORD_ID = process.env.REACT_APP_PASSWORD_ID;
export const PASSWORD_SECRET = process.env.REACT_APP_PASSWORD_SECRET;
export const DATE_FORMAT = "MM-dd-yyyy";
export const TIME_FORMAT = "HH:mm";
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const API_URL = process.env.REACT_APP_API_URL || "";